export default __webpack_public_path__ + "static/media/nodejs.99ef8ff9.svg";